import { z } from 'zod'
import { todayDateOnlyLocal } from './campaign-schema'

export const END_DATE_PAST_MESSAGE =
  'End date cannot be in the past. Please select a valid date.'
export const END_DATE_BEFORE_START_MESSAGE =
  'End date cannot be earlier than the campaign start date.'

function dateOnly(value: string): string | null {
  const trimmed = value.trim()
  if (!/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) return null
  const parsed = new Date(`${trimmed}T00:00:00.000Z`)
  if (!Number.isFinite(parsed.getTime())) return null
  return trimmed
}

export function campaignDurationEndDateSchema(startDateOnly: string) {
  return z
    .object({
      endDate: z
        .string()
        .min(1, END_DATE_PAST_MESSAGE)
        .refine((value) => dateOnly(value) != null, END_DATE_PAST_MESSAGE),
    })
    .superRefine((value, ctx) => {
      const end = dateOnly(value.endDate)
      if (!end) return
      const today = todayDateOnlyLocal()
      if (end < today) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: END_DATE_PAST_MESSAGE,
          path: ['endDate'],
        })
      }
      if (startDateOnly && end < startDateOnly) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: END_DATE_BEFORE_START_MESSAGE,
          path: ['endDate'],
        })
      }
    })
}

export type CampaignDurationFormData = z.infer<
  ReturnType<typeof campaignDurationEndDateSchema>
>
